import { ReactElement, useContext } from 'react';

import { useTheme, useMediaQuery, Button } from '@mui/material';

import { merge } from 'lodash';

import { FooterProps } from './types';

import { ModalContext } from '../..';
import HStack from '../../../Stacks/HStack';
import { ModalContext as ModalContextType } from '../../types';

export default function Footer({ renderAction, sx, ...rest }: FooterProps): ReactElement {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  const { onClose } = useContext<ModalContextType>(ModalContext);

  return (
    <HStack
      width='100%'
      alignItems='center'
      justifyContent={onClose ? 'space-between' : 'flex-end'}
      spacing={0}
      px={isXs ? 2 : 3}
      py={2}
      {...rest}
      sx={{ ...merge({ backgroundColor: 'grey.50' }, sx) }}>
      {onClose ? (
        <Button color='secondary' onClick={() => onClose()} size='medium' variant='outlined'>
          Cancel
        </Button>
      ) : null}

      {renderAction({ color: 'primary', size: 'medium', variant: 'contained' })}
    </HStack>
  );
}
